import React, { useEffect } from "react";
import {
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Checkbox,
  List,
  ListItem,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useService } from "@xstate/react";
import {
  service,
  DownloadEventType,
} from "@uidaholib/shared/machines/download/download.machine";
import { flatten } from "ramda";
import { observer } from "mobx-react-lite";
import { downloadStore } from "@uidaholib/shared/models/download/download";
import { setConfig } from "@uidaholib/shared/constants/config";

export const DownloadModal = observer(({ appName }) => {
  const [state, send] = useService(service);
  const { isOpen, onOpen, onClose } = useDisclosure(false);

  const modalIsOpen = state.matches({ initialized: "loaded_urls" });
  useEffect(() => {
    if (modalIsOpen) onOpen();
  }, [modalIsOpen]);

  useEffect(() => {
    setConfig(appName);
  }, []);

  const downloadRasters = () => {
    send({
      type: DownloadEventType.DOWNLOAD,
      payload: { links: downloadStore.links() },
    });
  };

  const title = "Download Raster Images";

  const filters = flatten(
    downloadStore.filters.filter((f) => f.selected).map((f) => f.title)
  );

  return (
    <Modal isCentered onClose={onClose} size="md" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent zIndex={70}>
        <ModalHeader>
          <Text>{title}</Text>
          <Flex fontSize="md">
            <Text mr={3}>Show</Text>
            <Flex>
              {downloadStore.filters.map((filter) => (
                <Checkbox
                  mr={2}
                  key={filter.title}
                  onChange={() => filter.toggleSelected()}
                  isChecked={filter.selected}
                  value={filter.title}
                >
                  {filter.title}
                </Checkbox>
              ))}
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <List spacing={2}>
            {downloadStore.urls
              .filter((u) => filters.includes(u.type))
              .map((url) => (
                <ListItem key={url.title}>
                  <Checkbox
                    value={url.title}
                    onChange={() => url.toggleSelected()}
                    isChecked={url.selected}
                  >
                    {url.title}
                  </Checkbox>
                </ListItem>
              ))}
          </List>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" mr={2} onClick={downloadRasters}>
            Download
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
